import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';
import { createQuerySchemaWithPagination } from '../shared';

export const selectLettingSchema = createSelectSchema(schema.lettings);

export const insertLettingSchema = createInsertSchema(schema.lettings, {
  date: z.date(),
  proposalCount: z.number().int().min(0),
  ownerId: z.string().uuid(),
});

export const updateLettingSchema = insertLettingSchema.partial().extend({
  id: z.string(),
});

const LettingsQuerySchema = z.object({
  'owner.name': z.string().optional(),
  identifier: z.string().optional(),
  ownerId: z.uuid().optional(),
  date: z
    .string()
    .optional()
    .transform((val) => {
      if (!val) {
        return [];
      }
      return val.split(',').map((num) => Number(num));
    })
    .default([]),
  // Filter to lettings that have at least one proposal in any of
  // these counties (UUIDs). Used by cross-table questions like
  // "lettings that had bids in Edgefield County".
  counties: z
    .string()
    .optional()
    .transform((val) => (val ? val.split(',').filter(Boolean) : undefined)),
});

export const getLettingsQuerySchema = createQuerySchemaWithPagination(
  LettingsQuerySchema,
  { id: 'date', desc: true },
);

export const getLettingsCountQuerySchema = LettingsQuerySchema;
